"use client";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/PlaidImportModal/openPlaidImportModal";

import { EdgenModalCreateAble } from "@components/EdgenModal";
import { callEdgenModalWhenRootReadyAsync } from "@components/EdgenModal/waitForEdgenModalRoot";

import { PlaidImportModalContent } from "./PlaidImportModalContent";
import { plaidImportModalShellProps } from "./plaidImportModalShell";
import type {
  OpenPlaidImportModalParams,
  PlaidImportModalResult,
} from "./types";
import { OspToast } from "@ospweb/sdk-ui";

const I18n = I18nUtil.createScoped(Translations);

let pendingPlaidImportModal: Promise<PlaidImportModalResult> | null = null;

export const IS_PLAID_OPEN = process.env.NEXT_PUBLIC_PLAID_OPENED === "true";

/** Opens Plaid import modal — H5 fullscreen / PC 539×min(852px,90vh). */
export const openPlaidImportModal = (
  params: OpenPlaidImportModalParams = {},
): Promise<PlaidImportModalResult> => {
  if (!IS_PLAID_OPEN) {
    OspToast.info({
      // Plaid暂未开放，请稍后再试
      content: I18n.t("Coming soon, please choose other ways"),
    });
    return Promise.resolve({ action: "close" });
  }
  if (pendingPlaidImportModal) {
    return pendingPlaidImportModal;
  }

  const { mode = "default", onBindSuccess, accountTarget } = params;

  pendingPlaidImportModal = callEdgenModalWhenRootReadyAsync(
    () =>
      new Promise<PlaidImportModalResult>((resolve) => {
        let settled = false;

        let modalInstance: Promise<boolean> | undefined;

        const finish = (result: PlaidImportModalResult) => {
          if (settled) {
            return;
          }
          settled = true;
          pendingPlaidImportModal = null;
          if (!modalInstance) {
            EdgenModalCreateAble.end(false);
          } else {
            EdgenModalCreateAble.end(modalInstance, false);
          }
          resolve(result);
        };

        modalInstance = EdgenModalCreateAble.call({
          children: (
            <PlaidImportModalContent
              mode={mode}
              onBindSuccess={onBindSuccess}
              accountTarget={accountTarget}
              onClose={finish}
            />
          ),
          ...plaidImportModalShellProps(),
          showClose: false,
          maskClosable: false,
          destroyOnClose: true,
        });
      }),
  ).catch((error) => {
    pendingPlaidImportModal = null;
    throw error;
  });

  return pendingPlaidImportModal;
};
